/* Domande frequenti: usate dalla sezione FAQ della home, dal pre-rendering statico e dal dato strutturato FAQPage.
   Solo informazioni già presenti nel sito, raggruppate per tema. */
export const FAQ_GROUPS = [
    {
        title: "Azienda, marchi e zone servite",
        items: [
            {
                q: "Siete concessionari ufficiali Christ Wash Systems in Calabria?",
                a: "Sì. FTM Group S.r.l. è concessionario ufficiale Christ Wash Systems (Otto Christ AG) per la Calabria: vendita, installazione, ricambi originali e assistenza tecnica autorizzata di portali di lavaggio, tunnel, impianti self-service e impianti per il lavaggio di mezzi pesanti, direttamente sul territorio.",
            },
            {
                q: "Siete rivenditori Ravaglioli? In quali zone?",
                a: "Sì, siamo partner e rivenditori Ravaglioli per le attrezzature da officina: ponti sollevatori, colonne mobili, smontagomme, equilibratrici, assetto ruote 3D e linee per centri revisione. La divisione autoriparatore opera in tutto il Sud Italia.",
            },
            {
                q: "In quali zone del Sud Italia lavorate?",
                a: "La sede operativa è a Castrolibero (Cosenza). Per gli impianti di autolavaggio Christ siamo concessionari per tutta la Calabria (Cosenza, Catanzaro, Reggio Calabria, Crotone, Vibo Valentia). Per le altre divisioni — attrezzature officina, scaffalature industriali, depurazione acque, coperture, impianti industriali e controlli periodici — operiamo in tutto il Sud Italia.",
            },
        ],
    },
    {
        title: "Officine, gommisti e carrozzerie",
        items: [
            {
                q: "Fornite attrezzature per officine meccaniche?",
                a: "Sì, è il cuore della nostra divisione autoriparatore. Forniamo e installiamo ponti sollevatori Ravaglioli a due e quattro colonne e a forbice, strumentazione per la diagnosi, impianti di aspirazione gas di scarico, sistemi di gestione dell'olio nuovo ed esausto, utensileria e arredo officina, con assistenza diretta in Calabria e in tutto il Sud Italia.",
            },
            {
                q: "Lavorate anche con le carrozzerie?",
                a: "Sì. Per le carrozzerie forniamo forni di verniciatura, piani aspiranti e banchi di tiro, oltre a ponti sollevatori e sollevatori a forbice Ravaglioli, impianti di aria compressa, aspirazione dei gas di scarico e delle polveri, utensileria professionale e arredo officina Beta su misura, con installazione e manutenzione programmata da parte dei nostri tecnici.",
            },
            {
                q: "Cosa offrite ai gommisti?",
                a: "Smontagomme Ravaglioli automatici, equilibratrici con misurazione automatica e assetto ruote 3D a telecamere per allineamenti rapidi e precisi, oltre a ponti sollevatori dedicati al servizio gomme. Interveniamo con tecnici propri in Calabria e nel Sud Italia.",
            },
            {
                q: "Fornite attrezzature per i centri revisione?",
                a: "Sì. Forniamo e installiamo linee revisione certificate Ravaglioli per auto, moto e mezzi pesanti, con strumentazione omologata, destinate ai centri revisione e alle officine autorizzate. Non effettuiamo revisioni ai privati: forniamo le attrezzature a chi le esegue.",
            },
        ],
    },
    {
        title: "Concessionarie, mezzi pesanti e flotte",
        items: [
            {
                q: "Lavorate con le concessionarie auto?",
                a: "Sì, le concessionarie sono il nostro cliente più completo. Per loro seguiamo tutto: officina meccanica con ponti sollevatori Ravaglioli, carrozzeria con forni di verniciatura, piani aspiranti e banchi di tiro, servizio gomme con smontagomme, equilibratrici e assetto ruote 3D, linee revisione, impianti di lavaggio Christ come i portali ALPHA, NEOX o VEGA, arredo officina Beta, impianti di aria compressa, aspirazione gas e gestione olio, e controlli periodici sulle attrezzature, con un unico referente dal progetto all'assistenza.",
            },
            {
                q: "Avete soluzioni per officine camion e mezzi pesanti?",
                a: "Sì. Forniamo sollevatori e colonne mobili Ravaglioli per mezzi pesanti, smontagomme per ruote di camion e autobus, linee revisione per veicoli industriali e gli impianti di lavaggio automatici Christ NOVA e SUPERNOVA per camion, autobus e autoarticolati. Seguiamo officine camion e depositi con installazione, ricambi originali e assistenza dei nostri tecnici.",
            },
            {
                q: "Avete soluzioni di lavaggio per aziende di trasporto, flotte e noleggio?",
                a: "Sì. Per spedizionieri, aziende di trasporto pubblico e privato, flotte e società di noleggio proponiamo gli impianti Christ NOVA e SUPERNOVA per camion e autobus e i portali per vetture e furgoni come VEGA XL e BIG BERTHA, con assistenza dei nostri tecnici e ricambi originali.",
            },
        ],
    },
    {
        title: "Autolavaggi e stazioni di servizio",
        items: [
            {
                q: "Fornite impianti di lavaggio per stazioni di servizio e autolavaggi self-service?",
                a: "Sì. Siamo Concessionario Ufficiale Christ Wash Systems per la Calabria e seguiamo fornitura, installazione e assistenza. Proponiamo:\nportali di lavaggio ALPHA, CADIS, VEGA e NEOX, il portale senza spazzole FLUX e l'ibrido BIG BERTHA;\ntunnel di lavaggio EVO STAR;\npiste self-service con strutture BLADE e container tecnici SKIP;\ncoperture esterne e sistemi di riciclo delle acque.",
            },
        ],
    },
    {
        title: "Assistenza, preventivi e contatti",
        items: [
            {
                q: "Eseguite controlli periodici sulle attrezzature?",
                a: "Sì. Eseguiamo verifiche periodiche e manutenzione programmata sulle attrezzature e sugli impianti, con documentazione dei controlli effettuati, secondo le indicazioni dei costruttori e la normativa vigente. Così le attrezzature restano sicure, efficienti e in regola, in tutto il Sud Italia.",
            },
            {
                q: "Fate assistenza tecnica e fornite ricambi originali?",
                a: "Sì. Abbiamo tecnici sul territorio e utilizziamo solo ricambi originali dei costruttori: interveniamo in media entro 48–72 ore dalla chiamata e offriamo piani di manutenzione programmata con controlli periodici sulle attrezzature e sugli impianti.",
            },
            {
                q: "Come posso richiedere un sopralluogo o un preventivo?",
                a: "Compila il modulo nella sezione Contatti indicando la divisione di interesse, scrivi a info@ftmgroup.it oppure chiama il +39 0984 443552 (lunedì–venerdì 8:30–13:00 e 14:30–18:00). Sopralluogo e preventivo sono gratuiti e rispondiamo nel più breve tempo possibile.",
            },
        ],
    },
];

export const FAQ = FAQ_GROUPS.flatMap((g) => g.items);
